import { createFeatureSelector, createSelector } from '@ngrx/store';
import { articleAdapter, ArticleState } from './article.reducer';
import * as ArticleReducer from './article.reducer';

export const getArticleState = createFeatureSelector<ArticleState>('articles');

export const {
  selectAll: getAllArticles,
  selectEntities: getArticleEntities,
  selectIds: getArticleIds,
  selectTotal: getTotalArticles,
} = articleAdapter.getSelectors(getArticleState);

export const getCurrentPage = createSelector(
  getArticleState,
  (state: ArticleState) => state.currentPage
);

export const getTotalPages = createSelector(
  getArticleState,
  (state: ArticleState) => state.totalPages
);

export const getTotalItems = createSelector(
  getArticleState,
  (state: ArticleState) => state.totalItems
);

export const getLoading = createSelector(
  getArticleState,
  (state: ArticleState) => state.loading
);
export const selectAllArticles = createSelector(
  getArticleState,
  ArticleReducer.selectAllArticles
);

export const getSelectedArticle = createSelector(
  getArticleState,
  (state: ArticleState) => state.selectedArticle
);
export const getFeaturedArticle = createSelector(
  getArticleState,
  (state: ArticleState) => state.featuredArticle
);

export const getFirstSevenArticles = createSelector(getAllArticles, articles =>
  articles.slice(0, 7)
);

// export const getFeaturedArticle = createSelector(getAllArticles, articles =>
//   articles.find(element => {
//     return element.visual;
//   })
// );

export const getSecondFourArticles = createSelector(getAllArticles, articles =>
  articles.slice(7, 11)
);

export const getNextTenArticles = createSelector(getAllArticles, articles =>
  articles.slice(11, 21)
);
